// extracted by mini-css-extract-plugin
export default {"fields":"UJLIJe","gaps":"gp6v1H","time":"eSrhqG","mobile":"TeNVER"};